import { useEffect, useRef, useState } from 'react';
import type { FichaVendedor } from '../types';

interface Props {
  fichas: FichaVendedor[];
  selecionadaId: number;
  aoTrocar: (vendedorId: number) => void;
}

export default function SeletorVendedor({ fichas, selecionadaId, aoTrocar }: Props) {
  const [aberto, setAberto] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  const atual = fichas.find((f) => f.vendedor_id === selecionadaId) ?? fichas[0];

  // Fecha o menu ao clicar fora.
  useEffect(() => {
    if (!aberto) return;
    function aoClicarFora(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setAberto(false);
    }
    document.addEventListener('mousedown', aoClicarFora);
    return () => document.removeEventListener('mousedown', aoClicarFora);
  }, [aberto]);

  function escolher(ficha: FichaVendedor) {
    setAberto(false);
    if (ficha.vendedor_id === selecionadaId) return;
    aoTrocar(ficha.vendedor_id);
  }

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setAberto((v) => !v)}
        className="aperta flex h-14 w-full cursor-pointer items-center justify-between gap-3 whitespace-nowrap rounded-[18px] bg-background-50 px-4 text-left text-[15px] font-semibold text-foreground-900 shadow-pcard"
        aria-haspopup="listbox"
        aria-expanded={aberto}
      >
        <span className="truncate">{atual?.de_quem ?? ''}</span>
        <span className="flex h-5 w-5 shrink-0 items-center justify-center text-foreground-400">
          <i className={aberto ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} aria-hidden />
        </span>
      </button>

      {aberto && (
        <ul
          role="listbox"
          className="absolute left-0 right-0 z-20 mt-1 max-h-72 overflow-y-auto rounded-[18px] bg-background-50 py-1 shadow-pnav"
        >
          {fichas.map((ficha) => {
            const marcada = ficha.vendedor_id === selecionadaId;
            return (
              <li key={ficha.vendedor_id} role="option" aria-selected={marcada}>
                <button
                  type="button"
                  onClick={() => escolher(ficha)}
                  className="aperta flex w-full cursor-pointer items-center justify-between gap-3 px-4 py-3 text-left transition-colors hover:bg-background-100"
                >
                  <span className="flex min-w-0 flex-col">
                    <span className="truncate text-[14px] font-semibold text-foreground-900">
                      {ficha.de_quem}
                    </span>
                    <span className="mt-0.5 truncate text-[12px] text-foreground-500">
                      {ficha.faixa} · {ficha.vendidos} vendidos
                    </span>
                  </span>
                  {marcada && (
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center text-primary-500">
                      <i className="ri-check-line" aria-hidden />
                    </span>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}